import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { IDiningOptionEnum } from "@/api/interfaces/configurationLayouts";
import Loader from "@/base/components/Global/Loader";
import { NavigationPath } from "@/constants/navigation";
import { useAppDispatch, useAppSelector } from "@/store";
import { hasData } from "@/store/apiRequestStatusMachine";
import { resetShoppingCart, selectShoppingCart } from "@/store/shoppingCart";
import { initializeDiningCart } from "@/store/shoppingCart/actions";
import {
  getTheatreResource,
  resetTheatreResource,
  selectTheatreResource,
} from "@/store/theatreResource";
import { selectUserId } from "@/store/user";

const QrLandingPage = () => {
  const navigate = useNavigate();
  const { qrCode } = useParams();

  const shoppingCart = useAppSelector(selectShoppingCart);
  const userId = useAppSelector(selectUserId);
  const theatreResource = useAppSelector(selectTheatreResource);
  const dispatch = useAppDispatch();

  const [isReset, setIsReset] = React.useState(false);

  useEffect(() => {
    if (isReset) {
      return;
    }

    if (hasData(shoppingCart)) {
      // TODO: important - we should also send a clearance request. So that carts are not hoarded.
      // We also need to have the navbar button state reflect that the cart is cleared.
      dispatch(resetShoppingCart());
    }

    if (hasData(theatreResource)) {
      dispatch(resetTheatreResource());
    }

    if (!qrCode) {
      navigate(`${NavigationPath.Home}?source=qr`);
      return;
    }

    setIsReset(true);
  }, [isReset, shoppingCart, theatreResource, qrCode]);

  useEffect(() => {
    if (!isReset || !qrCode) {
      return;
    }

    dispatch(getTheatreResource({ barcodeWithoutChecksum: qrCode }))
      .unwrap()
      .catch((error: unknown) => {
        if (!(error && typeof error === 'object' && 'name' in error) || error.name !== "ConditionError") {
          console.error(`Could not find QR code "${qrCode}"`, error);
        }

        navigate(`${NavigationPath.Home}?source=qr`);
      });
  }, [isReset, qrCode]);

  useEffect(() => {
    if (!hasData(theatreResource) || !isReset) {
      return;
    }

    void dispatch(
      initializeDiningCart({
        theatreResourceId: theatreResource.state.ID,
        dttmRequestedDelivery: null,
        diningOptionId: IDiningOptionEnum.DINE_IN,
        customerPersonId: userId,
      }),
    ).finally(() => {
      navigate(`${NavigationPath.Home}?source=qr`);
    });
  }, [theatreResource, userId]);

  return <Loader isFullScreen />;
};

export default QrLandingPage;
